<template>
  <div
    class="modal"
    tabindex="-1"
    :id="id"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-ice">
        <div class="modal-header bg-cosmos p-3">
          <span>{{ headerTitel }}</span>
          <modal-close-button @confirmed="closeModal" />
        </div>
        <div
          class="modal-body"
          style="max-height: 70vh; overflow-y: auto"
        >
          <!-- Fehler -->
          <div
            v-if="
              response &&
              response.exception_list &&
              response.exception_list.length > 0
            "
          >
            <span class="font-weight-bold">
              {{ $t('global.notification_failed') }}:
            </span>

            <div
              v-for="(item, index) in parsedExceptions"
              :key="index"
              class="mt-3 pl-3"
              style="border-left: 3px solid #dc3545"
            >
              <!-- Fach-Header mit Link -->
              <div class="d-flex align-items-center mb-1">
                <strong>{{ item.fachName }}</strong>
                <a
                  v-if="item.path"
                  :href="'/' + item.path"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="ml-2 text-primary"
                  :title="$t('global.open_in_new_tab') || 'Im neuen Tab öffnen'"
                >
                  <font-awesome-icon icon="fa-solid fa-up-right-from-square" />
                </a>
              </div>

              <!-- Termine -->
              <ul class="mb-0 mt-1">
                <li
                  v-for="(termin, tIdx) in item.termine"
                  :key="tIdx"
                  class="small"
                >
                  <span class="text-muted mr-1">{{ termin.date }}</span>
                  <span>{{ termin.name }}</span>
                  <span
                    v-if="termin.conflictType"
                    class="badge badge-danger ml-2"
                    style="font-size: 0.7rem"
                  >
                    {{ termin.conflictType }}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <!-- Erfolge -->
          <div
            v-if="
              response &&
              response.success_list &&
              response.success_list.length > 0
            "
            class="mt-3"
          >
            <span class="font-weight-bold">
              Erfolgreich erstellte Termine ohne Konflikte:
            </span>
            <ul class="mt-1">
              <li
                v-for="(item, index) in response.success_list"
                :key="index"
                class="small"
              >
                {{ item.message }}
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row w-100">
            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-success mr-3"
                @click="onOk"
              >
                <span class="font-khand font-weight-bold">ok</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { modal } from '@/mixins/Modal'
  import ModalCloseButton from '@/components/global/ModalCloseButton.vue'

  export default {
    name: 'ResponseModalTermin',
    components: {
      ModalCloseButton,
    },
    props: {
      id: {
        type: String,
        default: 'response-modal-termin',
      },
      headerTitel: {
        type: String,
        default: 'Response',
      },
    },
    data() {
      return {
        response: {
          success_list: [],
          exception_list: [],
        },
      }
    },
    mixins: [modal],
    computed: {
      parsedExceptions() {
        if (!this.response?.exception_list?.length) return []
        return this.response.exception_list.map((item) => {
          const lines = (item.message || '').split('\n')
          const fachName = lines[0].replace(/:$/, '').trim()
          const termine = lines
            .slice(1)
            .map((line) => {
              // Format: "  • 2032-09-27 – TerminName (KonfliktTyp)"
              const trimmed = line.replace(/^\s*•\s*/, '').trim()
              if (!trimmed) return null

              const conflictMatch = trimmed.match(/\(([^)]+)\)$/)
              const conflictType = conflictMatch ? conflictMatch[1] : ''
              const withoutConflict = trimmed
                .replace(/\s*\([^)]+\)$/, '')
                .trim()

              const sep = ' \u2013 ' // " – "
              const sepIdx = withoutConflict.indexOf(sep)
              const date =
                sepIdx >= 0 ? withoutConflict.substring(0, sepIdx) : ''
              const name =
                sepIdx >= 0
                  ? withoutConflict.substring(sepIdx + sep.length)
                  : withoutConflict

              return { date, name, conflictType }
            })
            .filter(Boolean)

          return { fachName, termine, path: item.path }
        })
      },
    },
    mounted() {
      this.$bus.$on('openResponseModalTermin', (response) => {
        const data = response.data || response
        if (
          (data.success_list && data.success_list.length > 0) ||
          (data.exception_list && data.exception_list.length > 0)
        ) {
          this.response = data
        } else {
          return
        }

        $('#' + this.id).modal({
          backdrop: 'static',
          keyboard: false,
        })
      })
    },
    methods: {
      closeModal() {
        $('#' + this.id).modal('hide')
        this.$emit('ok')
      },
      onOk() {
        this.closeModal()
        this.$emit('ok')
      },
    },
  }
</script>
